
/* eslint-disable */
export default {
    name: 'NextPage',
    props: ['text', 'dataLen'],
    data() {
        return {
            
        }
    },
    template: 
    `<div class="next-page-container" >
          <Button type="primary" long v-on:click="handler" :disabled="dataLen===0" class="ivu-btn  ivu-btn-primary ivu-btn ivu-btn-long">
              <span v-if="dataLen===0" >没有数据了</span>
              <span v-if="dataLen>0" >{{text}}</span>
          </Button>
      </div>`,
    methods: {
        handler() {
            this.$emit('mousetouch');
        }
    }
}

